// 上部広告（include/ad-top.php）が配信されている間、固定ヘッダーを広告の下に置き、
// 広告をスクロールで通り過ぎたら通常どおり画面上部に固定する（v3 stickyHeader.js の is-header-fixed と同じ動き）。
// 位置の切り替えは _component/_ad.scss の .has-v4-top-ad / .is-v4-top-ad-passed。

let offset = 0; // 広告の下端（ページ先頭からの距離 px）。広告が出ていないときは 0。

// ヘッダーが画面上部に届くまでのスクロール量（richHeroHeader.js などが参照する）。
export const getTopAdOffset = () => offset;

export const topAd = () => {
  const body = document.body;
  const ad = document.querySelector('[data-v4-top-ad]');
  if (!ad) return;

  let isPassed = null;
  let ticking = false;

  // 広告を通り過ぎたかどうかの切り替え（スクロールごと）。
  const check = () => {
    ticking = false;
    const passed = window.scrollY >= offset;
    if (passed === isPassed) return;
    isPassed = passed;
    body.classList.toggle('is-v4-top-ad-passed', passed);
  };

  // 広告の高さ・位置の計測（配信で広告が現れたとき・ナビ開閉・リサイズ時）。
  // ナビ展開中は広告が非表示になるので 0 になり、ヘッダーは通常の固定表示に戻る。
  const measure = () => {
    offset = ad.offsetHeight ? Math.round(ad.getBoundingClientRect().bottom + window.scrollY) : 0;
    body.style.setProperty('--v4-top-ad-height', offset + 'px');
    body.classList.toggle('has-v4-top-ad', offset > 0);
    check();
  };

  const requestCheck = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(check);
  };

  new ResizeObserver(measure).observe(ad);
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('scroll', requestCheck, { passive: true });
  measure();
};
